import { Paper } from "@material-ui/core";
import "./styles.scss";

const QuestionCard = ({ children }: { children: React.ReactNode }) => (
  <Paper className="questionContent">{children}</Paper>
);

export default QuestionCard;
